import { Environment } from "../../../environment";
import { Api, IPaginacao } from "../axios-config";

export interface IUsuario {
    idUsuario: number,
    nome: string,
    email: string,
    celular: string,
    uf: string,
    cpf: string,
    master?: boolean,
    gestor?: boolean,
    funcionarioZ?: boolean,
    alterarSenha?: boolean,
    validadeSenha?: string | null,
    senha?: string | null,
}

interface TUsuario {
    usuarios: IUsuario[];
    paginacao: IPaginacao;
}

const getAllByCnpj = async (cnpj: string | null | undefined, page = 1, estado: boolean): Promise<TUsuario | Error> => {
    try {
        if (cnpj === null || cnpj === undefined || cnpj === "") {
            const { data } = await Api.get(`Usuario?PageNumber=${page}&PageSize=${Environment.LIMITE_DE_LINHAS}&master=true&funcZ=true&estado=${estado}`);

            if (data) {
                return data;
            }
        } else {
            const { data } = await Api.get(`Usuario_cliente/pesquisar/UsuariosPorClientes?PageNumber=${page}&PageSize=${Environment.LIMITE_DE_LINHAS}&cnpj=${cnpj}&estadoUsuario=${estado}`);

            if (data) {
                return data;
            }
        }

        return new Error('Erro ao listar os registros');
    } catch (error) {
        console.error(error);

        //mostrar a mensagem que o back end retornou, caso não tenha retorna uma mensagem padrão
        return new Error((error as { message: string }).message || 'Erro ao listar os registros');
    }
};

const toggleEnabledById = async (idUsuario: number): Promise<void | Error> => {
    try {
        await Api.patch(`Usuario/alterarEstado?id=${idUsuario}`);
    } catch (error) {
        console.error(error);

        return new Error((error as { message: string }).message || 'Erro ao habilitar/desabilitar o registro');
    }
};


const create = async (dados: Omit<IUsuario, 'idUsuario'>, vincularAd: boolean): Promise<number | Error> => {
    try {
        const { data } = await Api.post<IUsuario>('/Usuario?vincularAd='+vincularAd, dados);

        if (data) {
            return data.idUsuario;
        }

        return new Error('Erro ao criar o registro');
    } catch (error) {
        console.error(error);

        //mostrar a mensagem que o back end retornou, caso não tenha retorna uma mensagem padrão
        return new Error((error as { message: string }).message || 'Erro ao criar o registro');
    }
};

const getById = async (idUsuario: number): Promise<IUsuario | Error> => {
    try {
        const { data } = await Api.get(`Usuario/id?id=${idUsuario}`);

        if (data) {
            return data;
        }

        return new Error('Erro ao listar o registro');
    } catch (error) {
        console.error(error);

        //mostrar a mensagem que o back end retornou, caso não tenha retorna uma mensagem padrão
        return new Error((error as { message: string }).message || 'Erro ao listar o registro');
    }
};

const updateById = async (idUsuario: number, dados: IUsuario, vincularAd = false): Promise<void | Error> => {
    try {
        await Api.put(`Usuario?vincularAd=${vincularAd}`, dados);
    } catch (error) {
        console.error(error);

        //mostrar a mensagem que o back end retornou, caso não tenha retorna uma mensagem padrão
        return new Error((error as { message: string }).message || 'Erro ao atualizar o registro');
    }
};


export const UsuarioService = {
    getAllByCnpj,
    toggleEnabledById,
    create,
    getById,
    updateById,
}